// ==========================================
// FIREBASE CONFIGURATION - Allo Artisan
// ==========================================
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { 
  initializeFirestore, 
  persistentLocalCache, 
  persistentMultipleTabManager, 
  connectFirestoreEmulator, 
} from "firebase/firestore"; // Ajout des imports manquants
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Remplacez votre objet firebaseConfig actuel par celui-ci :
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBavgz1x6rzARUAgY7UxgBpq0_WQ3vgzy0",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "allo-project-site.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "allo-project-site",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "allo-project-site.firebasestorage.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "622779643632",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:622779643632:web:67e114737b69a26454b435",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-6M4M07SYYL"
};

// Initialize Firebase
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// 1. Initialize Firestore avec la NOUVELLE méthode de persistance (Remplace enableMultiTabIndexedDbPersistence)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

// 2. Initialize other services
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Emulators for development
if ((import.meta as any).env.DEV && (import.meta as any).env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("Connecté aux émulateurs Firebase");
}

export default app;
